import React, { useState, useEffect, useContext } from "react";
import CheckIcon from "@atlaskit/icon/glyph/check";
import Spinner from "@atlaskit/spinner";

import SimpleBar from "../../Simplebar";
import {
  ImagesContainer,
  ImageThumbnail,
  Label,
} from "../styled/StyledComponents";
import NoResults from "../NoResults";
import HardcodedImages from "./HardcodedImages";
import { BackgroundDialogContext } from "../Context";
import { getLocalStorage, setLocalStorage } from "../storageService";
import {
  styleguideService,
  styleguidePropertyKeys,
} from "@Shared/Service/StyleguideService";

function Library() {
  const [isLoading, setIsLoading] = useState(true);
  const [images, setImages] = useState([]);
  const [recent] = useState(getLocalStorage("library"));

  const { image, setImage, isMulti } = useContext(BackgroundDialogContext);

  useEffect(() => {
    styleguideService
      .getProperty(styleguidePropertyKeys.GALLERY)
      .then((res) => {
        if (res.data.length) {
          setImages([...res.data]);
        } else {
          setImages([...HardcodedImages]);
        }
      })
      .catch(() => setImages([...HardcodedImages]))
      .finally(() => setIsLoading(false));
  }, []);

  const onImageClick = (img) => {
    setLocalStorage("library", [img, ...recent]);

    if (isMulti) {
      if (image.find(({ id }) => id === img.id)) {
        return setImage([...image.filter(({ id }) => id !== img.id)]);
      }
      return setImage([
        ...image,
        {
          source: "library",
          link: img.source,
          id: img.id,
        },
      ]);
    }
    return setImage({
      source: "library",
      link: img.source,
      id: img.id,
    });
  };

  const showImages = (images) => {
    return images.map((img) => (
      <ImageThumbnail
        key={img.id}
        isSelected={
          isMulti ? image.find(({ id }) => id === img.id) : image.id === img.id
        }
        height="90px"
        onClick={() => onImageClick(img)}
      >
        <CheckIcon size="small" />

        <img src={img.thumb || img.source} alt="Preview" />
      </ImageThumbnail>
    ));
  };

  // if (!images.length) {
  //   return (
  //     <NoResults
  //       label="Your image library is empty."
  //       content="Your organisation can add images to the image library in the style
  //       guide."
  //     />
  //   );
  // }

  return (
    <SimpleBar
      style={{
        height: "calc(100% - 95px)",
        width: "393px",
        position: "absolute",
      }}
    >
      {!recent.length || (
        <>
          <Label>Recent</Label>
          <ImagesContainer style={{ marginBottom: "20px" }}>
            {showImages(recent)}
          </ImagesContainer>
        </>
      )}

      <Label>All</Label>

      {isLoading ? (
        <div style={{ textAlign: "center" }}>
          <Spinner size="large" />
        </div>
      ) : (
        <ImagesContainer>{showImages(images)}</ImagesContainer>
      )}
    </SimpleBar>
  );
}

export default Library;
